<template>
  <div class="offset">
    <div class="container">
      <div class="transfers">
        <div class="transfers-content">
          <div class="head-title">
            {{ title }}
          </div>
          {{ mainFields.description?.value }}
          <div class="transfers-footer">
            <a
              v-if="mainFields?.link?.value?.startsWith(['https://'])"
              :href="mainFields?.link?.value"
              target="_blank"
              class="btn btn--full"
            >
              Подробнее
            </a>
            <nuxt-link
              v-else
              :to="{ path: mainFields?.link?.value?.[0] === '/' ? mainFields?.link?.value : `/${mainFields?.link?.value}` }"
              class="btn btn--full"
            >
              Подробнее
            </nuxt-link>
          </div>
        </div>
        <div class="transfers-aside">
          <img
            :src="getSvgPath(mainFields.icon?.value)"
            width="340"
            height="85"
            loading="lazy"
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import staticBlockMixin from '~/mixins/staticBlockMixin'

export default {
  mixins: [staticBlockMixin]
}
</script>
